/* eslint-disable import/no-unused-modules */

export const PRIMARY_BUTTON_COLOR = '#D87F5C';

export const proposalProductColumnsClass = 'grid-cols-[43%_17%_11%_13%_5%_11%]';
export const proposalQuotePaymentColumnsClass =
    'grid-cols-[56%_12%_10%_10%_12%]';
export const proposalInvoicePaymentColumnsClass =
    'grid-cols-[56%_11%_11%_11%_11%]';
